module.exports = {
	"en": "English",
	"pt": "Português"
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/language-names.yaml
// module id = 14
// module chunks = 4